export const REMOTE = {
    id: '5b063a66-bff2-4d06-b018-17fc7171b339',
    name: 'Віддалено'
  },
  ONLINE = {
    id: '5b063a66-bff2-4d06-b018-17fc7171b340',
    name: 'Online'
  };
